/**
 * Created by koqiui on 2017-04-12.
 */
import api from './index';

let exports = {};
//
exports.updateRetailerLogo = function (data, done, fail) {// 验证零售商信息
    api.post('/retailer/update/do')
    .data(data)
    .done(done)
    .go();
};
//
exports.getRetailerCheckResult = function (data, done, fail) {// 验证零售商信息
    api.post('/retailer/check/result/get')
    .data(data)
    .done(done)
    .fail(fail || done)
    .go();
};

exports.getRetailerPubAgreementList = function (data, callback) {// 获取公共协议
    api.post('/retailer/pub/agreement/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.saveRetailerPubAgreement = function (data, callback) {// 保存公共协议
    api.post('/retailer/pub/agreement/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.updateRetailerPubAgreement = function (data, callback) {// 更新公共协议
    api.post('/retailer/pub/agreement/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.deleteRetailerPubAgreement = function (data, callback) {// 删除公共协议
    api.post('/retailer/pub/agreement/delete/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getRetailerList = function (data, callback) {// 获取零售商
    api.post('/retailer/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.getRetailer = function (data, callback) {// 获取零售商
    api.post('/retailer/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 检测商户名称是否存在
exports.existRetailerByName = function (data, callback) {// 检查name
    api.post('/retailer/exist/do/by/name')
    .data(data)
    .done(callback)
    .go();
};
exports.applyRetailer = function (params, callback) {// 申请零售商
    api.post('/retailer/apply/do')
    .data(params)
    .done(callback)
    .go();
};
exports.reApplyRetailer = function (params, callback) {// 审核未通过后重新申请零售商
    api.post('/retailer/reApply/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

//回显数据
exports.getRetailerInfoByAdminId = function (params, callback) {// 回显数据
    api.post('/retailer/get/info/by/adminId')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getRetailerListByUserId = function (params, callback) {// 根据id查询
    api.post('/retailer/list/get/by/userId')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getRetailerMailboxList = function (params, callback) {// 获取业务邮箱列表
    api.post('/retailer/mailbox/list/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

exports.saveRetailerMailbox = function (params, callback) {// 保存业务邮箱
    api.post('/retailer/mailbox/save/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

exports.updateRetailerMailbox = function (params, callback) {// 更新业务邮箱
    api.post('/retailer/mailbox/update/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getRetailMailbox = function (data, callback) {// 获取业务邮箱
    api.post('/retailer/mailbox/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.updateRetailerMailboxDefalut = function (params, callback) {// 设置为默认邮箱
    api.post('/retailer/mailbox/update/default/do')
    .params(params)
    .done(callback)
    .go();
};

exports.deleteRetailMailbox = function (params, callback) {// 删除业务邮箱
    api.post('/retailer/mailbox/delete/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

// 获取公司列表
exports.getRetailerCostOrPrftCenterCodeMaps = function (params, callback) {// 获取零售商公司列表
    api.post('/retailer/com/costOrPrft/centerCode/maps/get')
    .data(params)
    .done(callback)
    .go();
};
// 获取公司列表
exports.getRetailerComList = function (params, callback) {// 获取零售商公司列表
    api.post('/retailer/com/list/get')
    .data(params)
    .done(callback)
    .go();
};
// 获取公司列表
exports.getRetailerComBizUnitList = function (params, callback) {// 获取零售商公司列表
    api.post('/retailer/biz/unit/com/list/get')
    .data(params)
    .done(callback)
    .go();
};
exports.getRetailerComByIds = function (params, callback) {
    api.post('/retailer/com/list/get/by/ids')
    .data(params)
    .done(callback)
    .go();
};

// 根据父id获取公司列表
exports.getRetailerComListByParentId = function (params, callback) {
    api.post('/retailer/com/list/get/by/parentId')
    .data(params)
    .done(callback)
    .go();
};

// 根据id获取公司信息
exports.getRetailerCom = function (params, callback) {// 获取零售商公司信息
    api.post('/retailer/com/get')
    .sync(true)
    .data(params)
    .done(callback)
    .go();
};

// 获取当前公司的管理员
exports.getRetailerComAdmin = function (params, callback) {// 获取子公司的管理员
    api.get('/retailer/com/admin/get')
    .params(params)
    .done(callback)
    .go();
};
exports.getRetailerComCountByCostPrft = function (params, callback) {
    api.post('/retailer/com/count/by/costPrft')
    .sync(true)
    .data(params)
    .done(callback)
    .go();
};

exports.saveRetailerCom = function (params, callback) {// 保存零售商公司
    api.post('/retailer/com/save/do')
    .data(params)
    .done(callback)
    .go();
};
exports.updateRetailerCom = function (params, callback) {// 更新零售商公司
    api.post('/retailer/com/update/do')
    .data(params)
    .done(callback)
    .go();
};
exports.updateRetailerComPrincipalInfo = function (data, callback) {// 设置机构负责岗、负责人
    api.post('/retailer/com/principalInfo/update/do')
    .data(data)
    .done(callback)
    .go()
};
exports.updateRetailerComForBizParam = function (params, callback) {// 更新零售商公司-业务参数信息
    api.post('/retailer/com/update/biz/param/do')
    .data(params)
    .done(callback)
    .go();
};
exports.moveRetailerComSeq = function (params, callback) {// 上下移条目
    api.post('/retailer/com/seq/move/do')
    .data(params)
    .done(callback)
    .go();
};
exports.getComForExport = function (params, callback) {// 上下移条目
    api.post('/retailer/com/export/do')
    .data(params)
    .done(callback)
    .go();
};
exports.getComForExportQrCode = function (params, callback) {// 导出机构二维码数据
    api.post('/retailer/com/export/qrCode/do')
    .data(params)
    .done(callback)
    .go();
};
// 获取岗位关联的人员列表
exports.getComRoleRefStaffList = function (params, callback) {// 获取零售商人员列表
    api.post('/retailer/com/role/ref/staff/list/get')
    .data(params)
    .done(callback)
    .go();
};

// 获取公司人员列表
exports.getRetailerStaffList = function (params, callback) {// 获取零售商人员列表
    api.post('/retailer/staff/list/get')
    .data(params)
    .done(callback)
    .go();
};
// 获取公司人员列表
exports.getRetailerStaffListSelect = function (params, callback) {// 获取零售商人员列表
    api.post('/retailer/staff/list/select/get')
    .data(params)
    .done(callback)
    .go();
};

// 获取公司人员列表--暂用于 发送站内信
exports.getRetailerStaffListForMsg = function (data, callback) {
    api.post('/retailer/staff/list/get/for/msg')
    .data(data)
    .done(callback)
    .go();
};

// 获取 当前公司及下级公司 的人员列表
exports.getRetailerStaffListForBizMsg = function (data, callback) {
    api.post('/retailer/staff/list/get/for/biz/msg')
    .data(data)
    .done(callback)
    .go();
};

// 根据手机号码校验人员信息
exports.checkStaffInfoByPhoneNo = function (params, callback) {// 根据手机号码校验人员信息
    api.get('/retailer/check/staff/by/phoneNo')
    .params(params)
    .done(callback)
    .go();
};

// 保存公司人员
exports.saveRetailerStaff = function (params, callback) {// 保存零售商人员
    api.post('/retailer/staff/save/do')
    .data(params)
    .done(callback)
    .go();
};

// 导入批量 - 保存公司人员
exports.saveRetailerStaffList = function (data, callback) {// 导入批量 - 保存公司人员
    api.post('/retailer/staff/list/save/do')
    .data(data)
    .done(callback)
    .go();
};

// 获取公司人员信息
exports.getRetailerStaff = function (params, callback) {
    api.get('/retailer/staff/info/get')
    .params(params)
    .done(callback)
    .go();
};
// 获取机构负责人信息
exports.getRetailerStaffInfoByComId = function (params, callback) {
    api.get('/retailer/staff/info/get/by/comId')
    .params(params)
    .done(callback)
    .go();
};
// 获取公司人员信息
exports.getRetailerStaffInfoByComIdAndUserId = function (params, callback) {
    api.get('/retailer/staff/info/get/by/comId/and/userId')
    .params(params)
    .done(callback)
    .go();
};
// 更新公司人员
exports.updateRetailerStaff = function (params, callback) {// 更新零售商人员
    api.post('/retailer/staff/update/do')
    .data(params)
    .done(callback)
    .go();
};
// 启、禁用公司人员
exports.updateRetailerStaffForDisabled = function (data, callback) {
    api.post('/retailer/staff/update/disabled/do')
    .data(data)
    .done(callback)
    .go();
};
// 检查当前商户是否存在同名员工
exports.existStaffNameInfo = function (params, callback) {
    api.get('/retailer/exist/same/staffName')
    .params(params)
    .done(callback)
    .go();
};

// 检查是否存在其他商户
exports.existOtherMercht = function (params, callback) {// 检查是否存在其他商户
    api.post('/retailer/exist/other/mercht')
    .data(params)
    .done(callback)
    .go();
};

// 检查当前手机号是否已有不同员工姓名
exports.existDiffStaffName = function (params, callback) {// 检查是否存在其他商户
    api.post('/retailer/exist/diff/staffName')
    .data(params)
    .done(callback)
    .go();
};

// 指定管理员
exports.specifyRetailerChildComAdmin = function (params, callback) {
    api.post('/retailer/child/com/admin/specify/do')
    .data(params)
    .done(callback)
    .go();
};

//验证本公司是否有此人
exports.checkRetailerComStaffByUserId = function (postData, callback) {// 判断本公司是否有此人
    api.post('/retailer/com/staff/check/do/by/userId')
    .sync(true)
    .data(postData)
    .done(callback)
    .go();
};
//=======================零用商公司业务地址=====================
exports.getRetailerAddrPagedList = function (data, callback) {// 获取零售商公司地址列表
    api.post('/retailer/addr/paged/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getRetailerAddrList = function (data, callback) {// 获取零售商公司地址列表
    api.post('/retailer/addr/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getRetailerAddrInfo = function (data, callback) {// 获取公司业务地址信息
    api.post('/retailer/addr/info/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.saveRetailerAddr = function (data, callback) {// 保存公司业务地址
    api.post('/retailer/addr/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.deleteRetailerAddr = function (params, callback) {// 删除零售商公司地址
    api.post('/retailer/addr/delete/do')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
//设置默认发货
exports.updateDeliverGoodsAddrDefaulted = function (params, callback) {// 设置发货默认地址
    api.post('/retailer/deliver/goods/addr/defaulted/update/do')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
//设置默认收货
exports.updateRevcGoodsAddrDefaulted = function (params, callback) {// 设置收货默认地址
    api.post('/retailer/revc/goods/addr/defaulted/update/do')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
//设置收货
exports.updateRevcGoodsAddr = function (data, callback) {// 设置收货地址
    api.post('/retailer/revc/goods/addr/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//设置发货
exports.updateDeliverGoodsAddr = function (data, callback) {// 设置发货地址
    api.post('/retailer/deliver/goods/addr/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getRetailerShopListByMerchantId = function (data, callback) {// 获取零售商门店列表
    api.post('/retailer/shop/list/get/by/merchantId')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// ========================= 商户及公司 ==================

exports.getRetailerInfo = function (params, callback) {// 获取零售商信息
    api.get('/retailer/info/get')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
}
;

exports.getRetailerStaffListByComId = function (data, callback) {// 获取该公司的员工信息
    api.post('/retailer/staff/list/get/by/comId')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 零售商业务日志列表
exports.getRetailerBizLogList = function (postData, callback) {// 分页获取零售商业务日志列表
    api.post('/retailer/biz/log/list/get')
    .data(postData)
    .done(callback)
    .go();
};
// 零售商业务日志详细信息
exports.getRetailerBizLog = function (postData, callback) {// 获取零售商业务日志详细信息
    api.get('/retailer/biz/log/get')
    .params(postData)
    .done(callback)
    .go();
};
// 更改站点信接收者
exports.doSpecifyRetailerComReceiver = function (postData, callback) {
    api.post('/retailer/com/receiver/specify/do')
    .data(postData)
    .done(callback)
    .go();
};

//保存公司域名信息
exports.saveDoMainName = function (postData, callback) {// 保存公司域名信息
    api.post('/retailer/domain/save/do')
    .data(postData)
    .done(callback)
    .go();
};

exports.getRetailerOrgComList = function (data, callback) {// 获取零售商公司信息
    api.post('/retailer/org/com/list/get')
    .data(data)
    .done(callback)
    .go();
};
exports.saveRetailerComBatch = function (data, callback) {// 获取零售商公司信息
    api.post('/retailer/com/batch/save/do')
    .data(data)
    .done(callback)
    .go();
};
exports.deleteRetailerCom = function (data, callback) {// 删除零售商机构
    api.post('/retailer/com/delete/do')
    .data(data)
    .done(callback)
    .go();
};

exports.upgradeRetailerCom = function (data, callback) {// 删除零售商机构
    api.post('/retailer/com/upgrade/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.archiveRetailerCom = function (data, callback) {// 删除零售商机构
    api.post('/retailer/com/archive/do')
    .data(data)
    .done(callback)
    .go();
};

// ----------------------- 零售商门店标签 ----------------------------------
exports.getRetailerShopTagList = function (data, callback) {// 获取零售商门店标签信息
    api.post('/retailer/shop/tag/get/list')
    .data(data)
    .done(callback)
    .go();
};
exports.getRetailerShopTagListByContext = function (data, callback) {// 获取零售商门店标签信息
    api.post('/retailer/shop/tag/get/list/by/context')
    .data(data)
    .done(callback)
    .go();
};
exports.saveRetailerShopTag = function (data, callback) {// 保存零售商门店标签
    api.post('/retailer/shop/tag/save/do')
    .data(data)
    .done(callback)
    .go();
};
exports.delelteRetailerShopTag = function (data, callback) {// 删除零售商门店标签
    api.post('/retailer/shop/tag/delelte/do')
    .data(data)
    .done(callback)
    .go();
};
exports.getRetailerUserList = function (data, callback) {// 获取零售商人员列表(user)
    api.post('/retailer/user/list/get')
    .data(data)
    .done(callback)
    .go();
};
exports.getRetailerStaffByUserIdAndComId = function (data, callback) {// 获取零售商员工信息根据
    api.get('/retailer/staff/info/get/by/uk')
    .params(data)
    .done(callback)
    .go();
};
exports.doRetailerComStateCheck = function (data, callback) {
    api.get('/retailer/shop/state/check/do')
    .params(data)
    .done(callback)
    .go();
};
exports.checkReailerShopCloseState = function (data, callback) {// 零售商门店闭店检查下级机构
    api.get('/retailer/shop/close/state/check/do')
    .params(data)
    .done(callback)
    .go();
};
exports.doReailerShopClose = function (data, callback) {// 零售商门店闭店
    api.post('/retailer/shop/close/do')
    .data(data)
    .done(callback)
    .go();
};
exports.doReailerShopOpened = function (data, callback) {// 零售商门店开店
    api.post('/retailer/shop/opened/do')
    .data(data)
    .done(callback)
    .go();
};
exports.doReailerShopClosing = function (data, callback) {
    api.post('/retailer/shop/closing/do')
    .data(data)
    .done(callback)
    .go();
};
exports.updateRetailerComContacts = function (data, callback) {// 同步机构联系方式
    api.post('/retailer/com/contacts/update/do')
    .data(data)
    .done(callback)
    .go();
};
exports.updateRetailerComForJointId = function (data, callback) {// 零售商机构-手工设置机构对接Id
    api.post('/retailer/com/jointId/update/do')
    .data(data)
    .done(callback)
    .go();
};
exports.updateRetailerBizAreaOrForm = function (data, callback) {// 同步机构经营业态、区域
    api.post('/retailer/com/bizAreaOrForm/update/do')
    .data(data)
    .done(callback)
    .go();
};
exports.updateRetailerComMgmtAreaId = function (data, callback) {// 同步机构经营业态、区域
    api.post('/retailer/com/mgmtAreaId/update/do')
    .data(data)
    .done(callback)
    .go();
};
exports.doRetailerPostAuthxEnabled = function (data, callback) {// 零售商统一设置权限开启
    api.post('/retailer/post/authx/enabled/do')
    .data(data)
    .done(callback)
    .go();
};

exports.getRetailerNoticeList = function (data, callback) {// 零售商统一设置权限开启
    api.post('/retailer/notice/list/page')
    .data(data)
    .done(callback)
    .go();
};
exports.getSubRetailerComRole = function (data, callback) {// 零售商统一设置权限开启
    api.post('/retailer/com/role/list/page')
    .data(data)
    .done(callback)
    .go();
};
exports.getRetailerComRoleListByDepartId = function (params, callback) {// 零售商统一设置权限开启
    api.get('/retailer/com/role/get/by/departId')
    .params(params)
    .done(callback)
    .go();
};
exports.saveRetailerNotice = function (data, callback) {// 零售商统一设置权限开启
    api.post('/retailer/notice/save')
    .data(data)
    .done(callback)
    .go();
};
exports.getRetailerNotice = function (params, callback) {// 零售商统一设置权限开启
    api.get('/retailer/notice/get/by/id')
    .params(params)
    .done(callback)
    .go();
};
exports.deleteRetailerNotice = function (params, callback) {// 零售商统一设置权限开启
    api.post('/retailer/notice/delete')
    .data(params)
    .done(callback)
    .go();
};
exports.sendRetailerNotice = function (params, callback) {// 零售商统一设置权限开启
    api.post('/retailer/notice/send')
    .data(params)
    .done(callback)
    .go();
};
exports.getRetailerComRoleListBySrcTblIds = function (data, callback) {// 零售商统一设置权限开启
    api.post('/retailer/com/role/get/by/src/tbl/ids')
    .data(data)
    .done(callback)
    .go();
};
// ======================= 个人收藏 =============================

// 个人收藏列表
exports.getRetailerStaffFavoriteCachedList = function (data, callback) {// 个人收藏列表
    api.post('/retailer/staff/favorite/cached/list/get')
    .data(data)
    .done(callback)
    .go();
};

// 保存个人收藏
exports.saveRetailerStaffFavorite = function (data, callback) {// 保存个人收藏
    api.post('/retailer/staff/favorite/save/do')
    .data(data)
    .done(callback)
    .go();
};

// 移除个人收藏
exports.deleteRetailerStaffFavorite = function (data, callback) {// 移除个人收藏
    api.post('/retailer/staff/favorite/delete/do')
    .data(data)
    .done(callback)
    .go();
};
exports.getRetailerXstaffList = function (data, callback) {// 零售商人员列表
    api.post('/retailer/xstaff/list/get')
    .data(data)
    .done(callback)
    .go();
};
exports.getRetailerXstaffUserIds = function (data, callback) {// 零售商人员UserIds
    api.post('/retailer/xstaff/userId/list/get')
    .data(data)
    .done(callback)
    .go();
};

// ========================== 查询配置 ===============================
// 查询元设结果配置信息 + 结果配置
exports.getQryResultMetaConf = function (params, callback) {
    api.get('/retailer/meta/query/result/get/by/code')
    .params(params)
    .done(callback)
    .go();
};

// 查询元设查询配置信息
exports.getMetaQueryConf = function (params, callback) {
    api.get('/retailer/meta/query/conf/get/by/code')
    .sync(true)
    .params(params)
    .done(callback)
    .go();
};
// 查询个性化查询配置-根据code
exports.getCustQueryConf = function (params, callback) {
    api.get('/retailer/cust/query/conf/get/by/code')
    .params(params)
    .done(callback)
    .go();
};

// 保存-个性化查询配置
exports.saveCustQueryConf = function (data, callback) {
    api.post('/retailer/cust/query/conf/save/do')
    .data(data)
    .done(callback)
    .go();
};

// ========================== 结果配置 ===============================
// 查询元设结果配置信息
exports.getMetaResultConf = function (params, callback) {
    api.get('/retailer/meta/result/conf/get/by/code')
    .params(params)
    .done(callback)
    .go();
};
// 查询个性化结果配置
exports.getCustResultConf = function (params, callback) {
    api.get('/retailer/cust/result/conf/get/by/code')
    .params(params)
    .done(callback)
    .go();
};
// 保存-个性化结果配置
exports.saveCustResultConf = function (data, callback) {
    api.post('/retailer/cust/result/conf/save/do')
    .data(data)
    .done(callback)
    .go();
};

// ========================= 业务标签管理 =========================

// 获取业务标签列表
exports.getBizTagPagedList = function (data, callback) {
    api.post('/retailer/biz/tag/list/get')
    .data(data)
    .done(callback)
    .go();
};
// 获取业务标签列表
exports.getBizTagList = function (data, callback) {
    api.post('/retailer/biz/tags/get')
    .data(data)
    .done(callback)
    .go();
};
exports.getBizTagListByBizAspect = function (filter, callback) {
    let data = {};
    data.filterItems = filter;
    exports.getBizTagList(data, callback);
};
// 根据id获取业务标签
exports.getBizTagById = function (params, callback) {
    api.get('/retailer/biz/tag/get/by/id')
    .params(params)
    .done(callback)
    .go();
};
// 保存业务标签
exports.saveBizTag = function (data, callback) {
    api.post('/retailer/biz/tag/save/do')
    .data(data)
    .done(callback)
    .go();
};
// 启禁用业务标签
exports.updateBizTagDisabledState = function (data, callback) {
    api.post('/retailer/biz/tag/disabled/state/update/do')
    .data(data)
    .done(callback)
    .go();
};
// 删除业务标签
exports.deleteBizTag = function (data, callback) {
    api.post('/retailer/biz/tag/delete/do')
    .data(data)
    .done(callback)
    .go();
};

// ========================= 附件标签管理 =========================

// 获取附件标签列表
exports.getAttTagPagedList = function (data, callback) {
    api.post('/retailer/att/tag/list/get')
    .data(data)
    .done(callback)
    .go();
};
// 获取附件标签列表
exports.getAttTagList = function (data, callback) {
    api.post('/retailer/att/tags/get')
    .data(data)
    .done(callback)
    .go();
};
exports.getAttTagListByAttAspect = function (filter, callback) {
    let data = {};
    data.filterItems = filter;
    exports.getAttTagList(data, callback);
};
// 根据id获取附件标签
exports.getAttTagById = function (params, callback) {
    api.get('/retailer/att/tag/get/by/id')
    .params(params)
    .done(callback)
    .go();
};
// 保存附件标签
exports.saveAttTag = function (data, callback) {
    api.post('/retailer/att/tag/save/do')
    .data(data)
    .done(callback)
    .go();
};
// 启禁用附件标签
exports.updateAttTagDisabledState = function (data, callback) {
    api.post('/retailer/att/tag/disabled/state/update/do')
    .data(data)
    .done(callback)
    .go();
};
// 删除附件标签
exports.deleteAttTag = function (data, callback) {
    api.post('/retailer/att/tag/delete/do')
    .data(data)
    .done(callback)
    .go();
};
exports.getRetailerMgmtAreaList = function (params, callback) {
    api.post('/retailer/mgmt/area/tree/list/get')
    .data(params)
    .done(callback)
    .go();
};

exports.getRealComTreeList = function (params, callback) {
    api.post('/retailer/real/com/tree/list/get')
    .data(params)
    .done(callback)
    .go();
};
exports.getRetailerAddrDefSendByComId = function (params, callback) {
    api.get('/retailer/addr/info/def/send/do')
    .params(params)
    .done(callback)
    .go();
};

// ============================= 零售组织机构属性、控制 =================================
// 获取零售组织机构属性、控制明细列表
exports.getRetailOrgPropCtrlDetailListFromCache = function (data, callback) {
    api.get('/retailer/org/prop/ctrl/detail/list/get/from/cache')
    .params(data)
    .done(callback)
    .go();
};
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/retailer.js
// module id = 8
// module chunks = 0